import styled from 'styled-components'
import { DEFAULT, PRODUCT_PAGE } from '../../constants/constants'
const MARGIN_BOTTOM_MOBILE = '30px'
const MARGIN_BOTTOM_DESKTOP = '60px'

export const DeliveryInfo = styled.div<{
  applicationMode: string
  $insideSummaryPanel: boolean
}>`
  display: flex;
  align-items: center;
  font-size: ${(props) => (props.applicationMode === PRODUCT_PAGE ? '14px' : '16px')};
  ${(props) => props.applicationMode === PRODUCT_PAGE && 'margin-top: 15px;'}
  margin-bottom: ${(props) => (props.$insideSummaryPanel ? MARGIN_BOTTOM_MOBILE : '0px')};

  @media (min-width: 1200px) {
    margin-bottom: ${(props) => (props.$insideSummaryPanel ? MARGIN_BOTTOM_DESKTOP : '15px')};
    ${(props) => props.applicationMode === PRODUCT_PAGE && 'align-self: flex-end;'}
  }

  .fa-tools,
  .fa-truck {
    margin-left: 5px;
    margin-right: 12px;
    color: ${(props) => props.theme.palette.primary.main};
  }

  .text {
    display: flex;
    flex-wrap: wrap;
    column-gap: 6px;
    ${(props) => props.applicationMode === DEFAULT && 'max-width: 300px;'}

    a {
      color: ${(props) => props.theme.palette.primary.main};
      text-decoration: none;
    }
  }
`
